import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api, errorText } from '../api';
import { TicketKarte, TicketNeuDialog } from '../components/Tickets';
import { Empty, Loading, Notice, TYP_LABEL } from '../components/ui';
import type { Ticket, TicketTyp } from '../types';

const ANSICHTEN = [
  { schluessel: 'meine', label: 'Meine offenen' },
  { schluessel: 'offen', label: 'Alle offenen' },
  { schluessel: 'eskaliert', label: 'Eskaliert' },
  { schluessel: 'abgeschlossen', label: 'Abgeschlossen' },
] as const;

export function TicketsPage() {
  const [params, setParams] = useSearchParams();
  const navigate = useNavigate();
  const ansicht = params.get('ansicht') ?? 'meine';
  const typ = params.get('typ') ?? '';
  const [q, setQ] = useState('');
  const [tickets, setTickets] = useState<Ticket[] | null>(null);
  const [fehler, setFehler] = useState('');
  const [neu, setNeu] = useState(false);

  useEffect(() => {
    const zeit = window.setTimeout(() => {
      api<Ticket[]>('/api/tickets', { query: { ansicht, typ, q } })
        .then(setTickets)
        .catch((e) => setFehler(errorText(e)));
    }, 200);
    return () => window.clearTimeout(zeit);
  }, [ansicht, typ, q]);

  const setze = (k: string, v: string) => {
    const p = new URLSearchParams(params);
    if (v) p.set(k, v);
    else p.delete(k);
    setParams(p, { replace: true });
  };

  return (
    <>
      <div className="kopf">
        <h1>Tickets</h1>
        <span className="spacer" />
        <button className="primary" onClick={() => setNeu(true)}>
          + Neues Ticket
        </button>
      </div>
      <div className="tabs">
        {ANSICHTEN.map((a) => (
          <button key={a.schluessel} className={a.schluessel === ansicht ? 'aktiv' : ''} onClick={() => setze('ansicht', a.schluessel)}>
            {a.label}
          </button>
        ))}
      </div>
      <div className="row" style={{ marginBottom: 14, flexWrap: 'nowrap' }}>
        <input placeholder="Suchen: Nummer, Titel, Kunde …" value={q} onChange={(e) => setQ(e.target.value)} />
        <select value={typ} onChange={(e) => setze('typ', e.target.value)} style={{ width: 200 }}>
          <option value="">Alle Arten</option>
          {(Object.keys(TYP_LABEL) as TicketTyp[]).map((t) => (
            <option key={t} value={t}>
              {TYP_LABEL[t]}
            </option>
          ))}
        </select>
      </div>
      {fehler && <Notice kind="error">{fehler}</Notice>}
      {!tickets ? (
        <Loading />
      ) : tickets.length === 0 ? (
        <Empty>Keine Tickets in dieser Ansicht.</Empty>
      ) : (
        <div className="ticketliste">
          {tickets.map((t) => (
            <TicketKarte key={t.id} t={t} zeigeZustaendig={ansicht !== 'meine'} />
          ))}
        </div>
      )}
      {neu && (
        <TicketNeuDialog
          onClose={() => setNeu(false)}
          onAngelegt={(t) => {
            setNeu(false);
            navigate(`/tickets/${t.id}`);
          }}
        />
      )}
    </>
  );
}
